import React from "react";

const CheckboxNew = ({
  id,
  label,
  checked,
  onChange,
  name,
  readOnly = false,
  style = {},
  hasError = false,
  labelPosition = "right", // "top", "bottom", "left", "right"
  helperText = "", // optional small text
}) => {
  const renderCheckbox = () => (
    <input
      type="checkbox"
      id={id}
      name={name}
      checked={checked}
      onChange={readOnly ? undefined : onChange}
      disabled={readOnly}
      style={{
        width: "12px",
        height: "12px",
        cursor: readOnly ? "not-allowed" : "pointer",
        margin: 0,
      }}
    />
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style, marginBottom: "6px" }}>
      {/* Checkbox + Label */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        {labelPosition === "left" && label && (
          <label
            htmlFor={id}
            style={{ fontSize: "0.85rem", color: "#000", cursor: readOnly ? "not-allowed" : "pointer" }}
          >
            {label}
          </label>
        )}
        {renderCheckbox()}
        {labelPosition === "right" && label && (
          <label
            htmlFor={id}
            style={{ fontSize: "0.85rem", color: "#000", cursor: readOnly ? "not-allowed" : "pointer" }}
          >
            {label}
          </label>
        )}
      </div>

   
      {helperText && (
        <span
          style={{
            fontSize: "0.75rem",
            color: "#6c757d",
            marginLeft: "22px", 
            marginTop: "2px",
            lineHeight: "1.2",
          }}
        >
          {helperText}
        </span>
      )}
    </div>
  );
};

export default CheckboxNew;
